import Keycloak from 'keycloak-js';

// Instance Keycloak RÉELLE (prod + tout build).
const realKeycloak = new Keycloak({
    url: 'https://auth.alta-pos.fr', // ou /auth si ancienne version
    realm: 'LoginCMSRealm', // Le nom de votre realm
    clientId: 'react-app-cms', // Le nom du client que vous avez créé dans Keycloak pour cette app
});

/**
 * BYPASS D'AUTHENTIFICATION — DÉVELOPPEMENT UNIQUEMENT.
 *
 * Verrou : `process.env.NODE_ENV === 'development'`. Create React App met NODE_ENV à
 * 'development' pour `react-scripts start` (serveur de dev) et à 'production' pour
 * `react-scripts build`. Ce bypass est donc PHYSIQUEMENT INACTIF dans tout bundle de prod
 * (la condition est fausse) -> IMPOSSIBLE à livrer par erreur.
 *
 * Il fournit un authClient factice déjà "authentifié" : le CMS s'ouvre sans serveur Keycloak,
 * pratique en local. Aucun secret, aucun appel réseau d'auth.
 */
function makeDevKeycloak() {
    // eslint-disable-next-line no-console
    console.warn('%c[DEV] Bypass Keycloak actif — authentification factice. NE JAMAIS activer en prod.',
        'color:#b45309;background:#fef3c7;padding:2px 6px;border-radius:4px;font-weight:bold');
    const noop = () => {};
    const ok = () => Promise.resolve(true);
    const kc = {
        authenticated: true,
        token: 'dev-token',
        idToken: 'dev-id-token',
        refreshToken: 'dev-refresh-token',
        subject: 'dev-user',
        tokenParsed: {
            given_name: 'Dev', family_name: 'Local',
            preferred_username: 'dev', email: 'dev@local',
        },
        realmAccess: { roles: ['ROLE_ADMIN'] },
        resourceAccess: {},
        // Hooks assignés par ReactKeycloakProvider (il y met notamment onReady) :
        onReady: noop, onAuthSuccess: noop, onAuthError: noop,
        onAuthRefreshSuccess: noop, onAuthRefreshError: noop, onAuthLogout: noop, onTokenExpired: noop,
        // Méthodes utilisées par l'app :
        login: ok,
        logout: () => { window.location.href = '/'; },
        register: ok,
        updateToken: () => Promise.resolve(false), // false = non rafraîchi mais token dev valide -> pas de logout
        clearToken: noop,
        hasRealmRole: () => true,
        hasResourceRole: () => true,
        loadUserProfile: () => Promise.resolve({ firstName: 'Dev', lastName: 'Local', username: 'dev' }),
        loadUserInfo: () => Promise.resolve({}),
        isTokenExpired: () => false,
        createLoginUrl: () => '#', createLogoutUrl: () => '#', createAccountUrl: () => '#',
        accountManagement: noop,
    };
    // Le provider fixe `initialized: true` dans le callback onReady (provider.js), PAS sur la
    // résolution de init(). On appelle donc onReady() (comme le vrai keycloak) juste après init.
    kc.init = () => {
        Promise.resolve().then(() => {
            if (typeof kc.onReady === 'function') kc.onReady(true);
            if (typeof kc.onAuthSuccess === 'function') kc.onAuthSuccess();
        });
        return Promise.resolve(true);
    };
    return kc;
}

// DOUBLE VERROU (sécurité) : le bypass n'est autorisé QUE si (1) build de dev (NODE_ENV) ET
// (2) on tourne réellement sur localhost. Raison : le Dockerfile a pu lancer `react-scripts start`
// (serveur de dev, NODE_ENV=development) en PROD -> sans ce 2e verrou, le bypass s'activait sur le
// domaine public = CMS sans authentification. Le contrôle d'hôte est infalsifiable côté serveur
// distant : sur auth.alta-pos/cms.* le hostname n'est jamais localhost -> vrai Keycloak forcé.
const isLocalhostRuntime =
    typeof window !== 'undefined' &&
    /^(localhost|127\.0\.0\.1|0\.0\.0\.0|\[::1\])$/.test(window.location.hostname);

const devBypassAllowed = process.env.NODE_ENV === 'development' && isLocalhostRuntime;

const keycloak = devBypassAllowed ? makeDevKeycloak() : realKeycloak;

export default keycloak;
